const EXTENSION_NAME = 'News';
const EXTENSION_ACTION = 'filterList';

const ROUTING__PAGINATE = '_paginate';
const ROUTING__FILTER = '_filter';

$(document).on('click', '[data-action="filter-records"]', function (e) {
  if (
    typeof $(this).data('extension-name') === 'undefined' ||
    $(this).data('extension-name') !== EXTENSION_NAME ||
    typeof $(this).data('controller-action') === 'undefined' ||
    $(this).data('controller-action') !== EXTENSION_ACTION
  ) {
    return;
  }
  e.preventDefault();

  const URI = window.location.href;
  const FORM = $(this).parents('form');
  const YEAR = FORM.find('#year').val();
  const SORT_BY = FORM.find('#sortBy').val();

  let uri;
  let buildTargetUri = '';

  if (URI.includes(ROUTING__FILTER)) {
    uri = URI.split(`/${ROUTING__FILTER}/`)[0];
  } else if (URI.includes(ROUTING__PAGINATE)) {
    uri = URI.split(`/${ROUTING__PAGINATE}/`)[0];
  } else {
    const LAST_CHAR = URI.slice(-1);
    if (LAST_CHAR === '/') {
      uri = uri.slice(0, -1);
    }
    uri = URI;
  }

  buildTargetUri = `${uri}/${ROUTING__FILTER}/${SORT_BY}`;
  if (YEAR !== '') {
    buildTargetUri = buildTargetUri.concat(`/${YEAR}`);
  }

  location.href = buildTargetUri;
});
